import { render, staticRenderFns } from "./AddGymAscentsBtn.vue?vue&type=template&id=51ed54dc"
import script from "./AddGymAscentsBtn.vue?vue&type=script&lang=js"
export * from "./AddGymAscentsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports